import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-estrella-real',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './estrella-real.component.html',
  styleUrl: './estrella-real.component.scss'
})
export class EstrellaRealComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.estrellaReal;
}
